import "./groupLife.css";
import {Link} from "react-router-dom"
import React, { useState, useEffect, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import men from "../images/men.png";
import Mobilemen from "../images/mobile-men.png"
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";
import ready from "../images/avc-ready.jpg";
import benefits from "../images/avc-benefits.jpg";
import groupBanner from "../images/group-banner.jpg";
import groupHow from '../images/group-how.png';
import groupStart from '../images/group-start.png';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Footer from "./footer";
import AOS from 'aos';

import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";


const client = new ApolloClient({
  link: new HttpLink({ uri: "https://pensure-cms.inspireleadership.biz/graphql"}),
  cache: new InMemoryCache(),
});


const Group = () => {

   window.scrollTo(0, 0)

   
const[heroBanner, setHeroBanner] = useState([])
      const [heroMobile, setHeroMobile] = useState([])
      const [listSections, setListSections] = useState([])
      const [businessSections, setBusinessSections] = useState([])


               useEffect( () => {
                         AOS.init({
                            offset: 0,
                            duration: 1000,
                            once: true
                     });
                                      
                                          
                     }, [])


   useEffect( () => {
        
        client
          .query({
            query: gql`
             query NewQuery {
  pages(first:100) {
    edges {
      node {
        groups {
          hero {
             herocaption
            herosubcaption
            buttonlink
            buttontext
            image {
              mediaItemUrl
            }
          }
          heromobile {
            buttonlink
            buttontext
            herocaption
            herosubcaption
            image {
              mediaItemUrl
            }
          }
          listSection {
            image {
              mediaItemUrl
            }
            itemList {
              item
            }
              heading
              caption
          }
          section {
            buttonLink
            buttonText
            explanation
            heading
            image {
              mediaItemUrl
            }
          }
        }
      }
    }
  }
        }
            `,
          })
          .then((result) => {
        
             
             console.log(result)
                    setHeroBanner(result.data.pages.edges[17].node.groups.hero)
                    setHeroMobile(result.data.pages.edges[17].node.groups.heromobile)
                   setListSections(result.data.pages.edges[17].node.groups.listSection)
                    setBusinessSections(result.data.pages.edges[17].node.groups.section)
        
      
        
        
          });
        
        }, []) 
   
              
          
      
        
        
            let listSectionsDisplay
                 
                        let heroBannerDisplay
                         let heroMobileBannerDisplay
                  
                        let businessSectionsDisplay
                        
                        
                        
                          if(heroBanner.length > 0 ){
                          heroBannerDisplay = heroBanner.map((banner, i) => 
                  
          <div className="group-cover">
          <img className="group-bg" src={banner.image.mediaItemUrl}  />
          <div className="group-content">
            <div className="group-txt">
              <h1 className="group-h1 " data-aos="zoom-in" data-aos-delay="200"> {banner.herocaption} </h1>
              <p className="grey-p-group" data-aos="fade-up" data-aos-delay="200">
               {banner.herosubcaption}    </p>
              <a href={banner.buttonlink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
                {" "}
               {banner.buttontext} {" "}
                <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
              </a>
            </div>
          </div>
        </div>
             
     
                        
                        
                          )
                        }
                  
                                if(heroMobile.length > 0 ){
                          heroMobileBannerDisplay = heroMobile.map((banner, i) => 
        
                                   <div className="group-cover">
          <img className="group-bg" src={banner.image.mediaItemUrl}  />
          <div className="group-content">
            <div className="group-txt">
              <h1 className="group-h1 " data-aos="zoom-in" data-aos-delay="200"> {banner.herocaption} </h1>
              <p className="grey-p-group" data-aos="fade-up" data-aos-delay="200">
               {banner.herosubcaption}    </p>
              <a href={banner.buttonlink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
                {" "}
               {banner.buttontext} {" "}
                <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
              </a>
            </div>
          </div>
        </div>
                                        
                          )
                        }
          
          
             if(listSections.length > 0){ 
                
                
                    listSectionsDisplay = listSections.map((section, i) => 
          
                       
                
                              i % 2 ? 
          
        
                 <div id="mobile-view"  className=" d-flex align-items-center justify-content-between pb-5">
                      
        
                     <div className="d-flex justify-content-end">
                            <img className="img-fluid" src={section.image.mediaItemUrl}/>
                          </div>
        
                <div  className="pension-div1 pb-5">
                  <h3 className="invest-h3 pb-2" data-aos="fade-up" data-aos-delay="200">{section.caption}</h3>
        
                 <p className="grey-p-invest  pb-2 " style={{ color: "#3B475A", width: "470px" }} data-aos="fade-up" data-aos-delay="200">
                    {section.caption}
                  </p>
        
                  <hr className="btm-bdr" style={{ borderTop: "none", width: "600px" }} />
        
                  <ul
                    className="pt-2 ps-3 custom-square"
                    style={{ listStyleType: "square", paddingLeft: "20px" }}
                  >
              
                          {section.itemList.map( (items,i) => 
                          
                         <li className="grey-p-rma pt-4" style={{ color: "#3B475A" }} data-aos="fade-up" data-aos-delay="200">
                       {items.item}
                      </li>
                  
                      )
                      
                      }
                   
                  </ul>
                </div>
        
                      
                          
                        </div>
                        
                    
                    :
        
        
        
                    
          
          
                 <div id="mobile-view"  className=" d-flex align-items-center justify-content-between pb-5">
                      
        
                <div  className="pension-div1 pb-5">
                  <h3 className="invest-h3 pb-2" data-aos="fade-up" data-aos-delay="200">{section.heading}</h3>
        
                 <p className="grey-p-invest  pb-2 " style={{ color: "#3B475A", width: "470px" }} data-aos="fade-up" data-aos-delay="200">
                    {section.caption}
                  </p>
        
                  <hr className="btm-bdr" style={{ borderTop: "none", width: "600px" }} />
        
                  <ul
                    className="pt-2 ps-3 custom-square"
                    style={{ listStyleType: "square", paddingLeft: "20px" }}
                  >
              
                          {section.itemList.map( (items,i) => 
                          
                         <li className="grey-p-rma pt-4" style={{ color: "#3B475A" }} data-aos="fade-up" data-aos-delay="200">
                       {items.item}
                      </li>
                  
                      )
                      
                      }
                   
                  </ul>
                </div>
        
                     <div className="d-flex justify-content-end">
                            <img className="img-fluid" src={section.image.mediaItemUrl}/>
                          </div>
        
                      
                          
                        </div>
                        
          
                      
                    )
                
                  }
                
          
          
                  if(businessSections.length > 0){ 
                  
                  
                      businessSectionsDisplay = businessSections.map((section, i) => 
                  
                                i % 2 ? 
                         
                                                  <div id="mobile-view"  className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5">
                               
                                
                                    
                                  <div className="values compact-section">
                                      <h3 className="h3 rsa-h3" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>
                                      <p className="grey-p pt-3 pb-5" style={{ fontSize: "16px", color: "#545454" }} data-aos="fade-up" data-aos-delay="200">
                                      {section.explanation}
                                      </p>
                  
                  
                                  <Link
                                    class="open-acc-btn grey-p mt-3"
                                    to={section.buttonLink}
                                    role="button"
                                    data-aos="fade-up" data-aos-delay="200"
                             
                                   >
                                    {section.buttonName}
                                    <FontAwesomeIcon className="rsa-dwn-arr" icon={faArrowRight} />
                                  </Link>
                                      
                                    </div>
                  
                                        <div className="d-flex justify-content-end">
                                      <img className="img-fluid" src={section.image.mediaItemUrl} />
                                    </div>
                                  </div>
          
                                                        
                      
                      :
                  
          
           <div id="mobile-view"  className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5">
                               
                                       <div className="d-flex justify-content-end">
                                      <img className="img-fluid" src={section.image.mediaItemUrl} />
                                    </div>
                                    
                                         <div className="values compact-section">
                                      <h3 className="h3 rsa-h3" data-aos="fade-up" data-aos-delay="200">{section.heading} </h3>
                                      <p className="grey-p pt-3 pb-5" style={{ fontSize: "16px", color: "#545454" }} data-aos="fade-up" data-aos-delay="200">
                                       {section.explanation} 
                                      </p>
                  
                  
                                  <Link
                                    class="open-acc-btn grey-p mt-3"
                                    to={section.buttonLink}
                                    role="button"
                                    data-aos="fade-up" data-aos-delay="200"
                                  
                                   >
                                    {section.buttonText} {" "}
                                    <FontAwesomeIcon className="rsa-dwn-arr" icon={faArrowRight} />
                                  </Link>
                                      
                                    </div>
                  
                                 
                                  </div>
                      
                      
                      )
                  
                    }
                  
   
  return (
    <>
      <div className="group-container d-none d-sm-block">
     {heroBannerDisplay}
      </div>

    <div className="group-container d-block d-sm-none">
     {heroMobileBannerDisplay}
      </div>

<div className="containeer padding-section-standard-top">


    {listSectionsDisplay}

         



    {businessSectionsDisplay}
      </div>
 
     <Footer/>
           <div className='height-prod'> 

              </div>
    </>
  );
};

export default Group;
